// extracted by mini-css-extract-plugin
module.exports = {"content":"readMore_content__bv7mp"};